import { QuestionCircleIcon } from '@mm/icons';
import classNames from 'classnames';
import React, { useState } from 'react';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { PrimaryToolTip } from '../../../../../../common/components/PrimaryToolTip/PrimaryToolTip';
import { FILTER_TYPES } from '@mm/state/model/AudiencesModel';
import { colors } from '../../../../beta/styles/colors';
import {
  AddFilterType,
  LocalSystemFilterItem,
  UpdateFilterType,
} from '../../../sharedFilterTypes';
import './EUMembership.scss';

type Props = {
  toggle: () => void;
  onFinish: AddFilterType;
  onUpdateFilter: UpdateFilterType;
  selectedFilter?: LocalSystemFilterItem;
  selectedFilterId?: number | null;
  className?: string;
};

export const EUMembership = (props: Props) => {
  const { selectedFilterId, className, toggle, onFinish, onUpdateFilter } =
    props;
  const [filterValue, setFilterValue] = useState(true);
  const onClose = () => {
    setFilterValue(true);
    toggle();
  };
  const onSave = () => {
    onFinish({
      value: [`${filterValue}`],
      filterType: FILTER_TYPES.euLimits,
    });
    if (filterValue) {
      onClose();
    }
  };
  const onUpdate = () => {
    if (selectedFilterId) {
      onUpdateFilter(selectedFilterId, {
        value: [`${filterValue}`],
        filterType: FILTER_TYPES.euLimits,
      });
    }
    onClose();
  };
  return (
    <div className={classNames(className, 'eu-membership')}>
      <div className="eu-membership__input-container">
        <input
          type="radio"
          checked={filterValue}
          onChange={() => setFilterValue(true)}
          className="eu-membership__radio-input"
        />
        EU
        <PrimaryToolTip
          position="top"
          align="end"
          classNameContent="eu-membership__info-tooltip"
          anchorElement={<QuestionCircleIcon color={colors.accentBlue} />}
        >
          Contacts impacted by FB's policy change for EU residents. More
          information{' '}
          <a
            href="https://mobilemonkey.com/help/article/cg1qvuexfy-updated-messaging-policies-for-eu-pages-users"
            target="_blank"
            rel="noopener noreferrer"
          >
            here.
          </a>
        </PrimaryToolTip>
      </div>
      <div className="eu-membership__input-container">
        <input
          type="radio"
          checked={!filterValue}
          onChange={() => setFilterValue(false)}
          className="eu-membership__radio-input"
        />
        Non-EU
        <PrimaryToolTip
          position="top"
          align="end"
          classNameContent="eu-membership__info-tooltip"
          anchorElement={<QuestionCircleIcon color={colors.accentBlue} />}
        >
          Contacts NOT impacted by FB's policy change for EU residents. More
          information here{' '}
          <a
            href="https://mobilemonkey.com/help/article/cg1qvuexfy-updated-messaging-policies-for-eu-pages-users"
            target="_blank"
            rel="noopener noreferrer"
          >
            here.
          </a>
        </PrimaryToolTip>
      </div>

      <div className="eu-membership__buttons">
        <PrimaryButton color={ButtonColor.secondaryBlue} onClick={onClose}>
          Cancel
        </PrimaryButton>
        {!selectedFilterId && (
          <PrimaryButton onClick={() => onSave()}>Save</PrimaryButton>
        )}
        {selectedFilterId && (
          <PrimaryButton onClick={onUpdate}>Update</PrimaryButton>
        )}
      </div>
    </div>
  );
};
